<template>
  <div class="grid-string grid-string-data">
    <ImportCellId
      :number="number"
      :validation-alerts="errorsToDisplay"
      :index="index"
      :validation-alerts-amount="amountErrors"
      @remove="$emit('remove')"
    />

    <ImportCell
      v-for="(field, i) in order"
      :key="field.slug"
      :cell-column-row="`${i}-${rowIndex}`"
      :field="order[i].slug"
      :row-id="id"
      :group-level="attrs.group_level"
      :text="getText(field)"
      :error="getCellError(field)"
      :error-position="getErrorPositionClasses(i)"
      @edit-cell-value="editCellValue"
    />
  </div>
</template>

<script>
  import ImportCellId from '@/components/import/CellId';
  import ImportCell from '@/components/import/Cell';
  import capitalize from '@/utils/formatting/capitalize';
  import contextMenu from '@/utils/mixins/context-menu';
  import request from '@/utils/api/request';
  import { mapActions } from 'vuex';

  export default {
    name: 'ImportListRow',
    components: { ImportCell, ImportCellId },
    mixins: [contextMenu],
    props: {
      order: {
        type: Array,
        default: () => [],
      },

      id: [String, Number],
      index: Number,
      number: [String, Number],
      created_at: String,
      attrs: {
        type: Object,
        default: () => ({}),
      },
      sheet_row_index: [Number, String],

      errors: {
        type: Object,
        default: null,
      },
      rowIndex: Number,
    },
    computed: {
      amountErrors() {
        return this.errors?.cells?.length + this.errors?.errors?.length || 0;
      },
      errorsToDisplay() {
        if (!this.errors) return [];

        let errs = [];
        this.errors?.errors?.forEach((err) => {
          errs.push({
            description: err?.description,
          });
        });

        this.errors?.cells?.forEach((err) => {
          errs.push({
            description: err?.description,
            where: `in "${capitalize(err?.field)}" column`,
          });
        });
        return errs;
      },
    },
    methods: {
      ...mapActions('alert', ['showAlert']),
      async editCellValue(params) {
        try {
          await request.put(`/import/row/${this.id}/field/`, {
            field: params.key,
            value: params.value,
          });
          this.$emit('edit-cell-value', { ...params, error: false });
        } catch (e) {
          if (e.response?.data) {
            const errors = Object.values(e.response.data)?.flat(1);
            if (errors?.length) {
              errors.forEach((error) => {
                this.showAlert({
                  type: 'error',
                  text: error,
                });
              });
            }
          }
          console.error(e);
          this.$emit('edit-cell-value', { ...params, error: true });
        }
      },
      getText(field) {
        if (field.modernizr) return field.modernizr(this.attrs[field.slug]);

        const val = this.attrs[field.slug] || this.attrs.custom_fields?.[field.slug];
        if (val) return val;
      },

      getCellError(field) {
        if (!this.errors) return null;
        return this.errors.cells?.find((err) => err.field === field.slug);
      },

      getErrorPositionClasses(i) {
        let ret = '';
        if (this.index < 3) ret += 'err-top ';
        else ret += 'err-bottom ';

        if (i < 2) ret += 'err-left';
        else ret += 'err-right';
        return ret;
      },
    },
  };
</script>
